module.exports = "./assets/images/pic1.jpeg";